import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

import {
    FaArrowLeft,
    FaStar,
    FaExclamationTriangle,
    FaShoppingCart,
    FaHeart,
    FaSyncAlt,
} from "react-icons/fa";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ProductCard from "./Catos";

import {
    useAddTodoMutation,
    useGetTodosQuery,
    useDeleteTodoMutation,
} from "../../redux/slices/productApiSlice";

import {
    useSelector,
} from "react-redux";

import {
    useAddsTodoMutation,
    useGetsTodosQuery,
    useDeleteeTodoMutation,
} from "../../redux/slices/todoApiSlice";

import {
    Swiper,
    SwiperSlide,
} from "swiper/react";

import {
    Navigation,
    Thumbs,
} from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import styles from "./Detalp.module.scss";


const Detalp = () => {

    const [product, setProduct] = useState(null);

    const [thumbsSwiper, setThumbsSwiper] = useState(null);

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState("");

    const [retryCount, setRetryCount] = useState(0);

    const [addingToCart, setAddingToCart] = useState(false);

    const [addingToFavorite, setAddingToFavorite] = useState(false);

    const [visibleLength, setVisibleLength] = useState(100);

    const [visibleLengthh, setVisibleLengthh] = useState(100);

    const { qolbaq_id } = useParams();

    const navigate = useNavigate();

    const { userInfo } = useSelector(
        (state) => state.auth
    );


    /* =========================================================
       CART RTK QUERY
    ========================================================= */

    const {
        data: cartData,
    } = useGetTodosQuery();

    const [addTodo] =
        useAddTodoMutation();

    const [deleteTodo] =
        useDeleteTodoMutation();


    /* =========================================================
       FAVORITE RTK QUERY
    ========================================================= */

    const {
        data: favoriteData,
    } = useGetsTodosQuery();

    const [addTodoo] =
        useAddsTodoMutation();

    const [deleteeTodo] =
        useDeleteeTodoMutation();


    /* =========================================================
       CART DATA
    ========================================================= */

    const cartItems =
        cartData?.todos ||
        cartData?.allTodos ||
        cartData?.products ||
        cartData ||
        [];


    /* =========================================================
       FAVORITE DATA
    ========================================================= */

    const favoriteItems =
        favoriteData?.todos ||
        favoriteData?.allTodos ||
        favoriteData?.favorites ||
        favoriteData ||
        [];


    /* =========================================================
       GET PRODUCT ID FROM CART / FAVORITE ITEM
    ========================================================= */

    const getProductId = (item) => {

        if (!item) {
            return null;
        }


        if (
            typeof item.productId === "string"
        ) {
            return item.productId;
        }


        if (
            item.productId?._id
        ) {
            return item.productId._id;
        }


        if (
            item.qolbaq?._id
        ) {
            return item.qolbaq._id;
        }


        if (
            item.product?._id
        ) {
            return item.product._id;
        }


        if (
            item._id &&
            item.title
        ) {
            return item._id;
        }


        return null;
    };


    /* =========================================================
       CURRENT CART ITEM
    ========================================================= */

    const cartItem =
        Array.isArray(cartItems)
            ? cartItems.find(
                  (item) =>
                      getProductId(item) ===
                      product?._id
              )
            : null;


    /* =========================================================
       CURRENT FAVORITE ITEM
    ========================================================= */

    const favoriteItem =
        Array.isArray(favoriteItems)
            ? favoriteItems.find(
                  (item) =>
                      getProductId(item) ===
                      product?._id
              )
            : null;


    /* =========================================================
       STATUS
    ========================================================= */

    const isInCart =
        Boolean(cartItem);

    const isFavorite =
        Boolean(favoriteItem);


    /* =========================================================
       ERROR MESSAGE
    ========================================================= */

    const getErrorMessage = (err) => {

        const status =
            err?.response?.status ||
            err?.status;


        const serverMessage =
            err?.response?.data?.message ||
            err?.response?.data?.error ||
            err?.response?.data?.data?.message ||
            err?.data?.message ||
            err?.data?.error ||
            err?.message;


        if (serverMessage) {

            if (
                typeof serverMessage ===
                "string"
            ) {
                return serverMessage;
            }


            try {

                return JSON.stringify(
                    serverMessage
                );

            } catch {

                return "Serverdən naməlum xəta cavabı alındı.";

            }

        }


        if (status === 400) {

            return "Göndərilən məlumatlar düzgün deyil.";

        }


        if (status === 401) {

            return "Bu əməliyyatı yerinə yetirmək üçün hesabınıza daxil olmalısınız.";

        }


        if (status === 403) {

            return "Bu əməliyyatı yerinə yetirmək üçün icazəniz yoxdur.";

        }


        if (status === 404) {

            return "Axtardığınız məhsul tapılmadı və ya artıq mövcud deyil.";

        }


        if (status === 409) {

            return "Bu məhsul artıq əlavə edilib.";

        }


        if (status === 429) {

            return "Çox sayda sorğu göndərildi. Bir neçə saniyə gözləyib yenidən cəhd edin.";

        }


        if (status >= 500) {

            return "Serverdə texniki problem baş verdi. Zəhmət olmasa, bir qədər sonra yenidən cəhd edin.";

        }


        if (
            err?.code ===
                "ERR_NETWORK" ||
            err?.message
                ?.toLowerCase()
                ?.includes("network")
        ) {

            return "Serverlə əlaqə yaratmaq mümkün olmadı. İnternet bağlantınızı yoxlayın.";

        }


        return "Naməlum xəta baş verdi. Zəhmət olmasa, yenidən cəhd edin.";
    };


    /* =========================================================
       DUPLICATE ERROR CHECK
    ========================================================= */

    const isAlreadyAddedError = (err) => {

        const status =
            err?.status ||
            err?.response?.status;


        const message = (
            err?.data?.message ||
            err?.data?.error ||
            err?.response?.data?.message ||
            err?.response?.data?.error ||
            err?.message ||
            ""
        )
            .toString()
            .toLowerCase();


        if (status === 409) {
            return true;
        }


        return (
            message.includes("already") ||
            message.includes("exist") ||
            message.includes("duplicate") ||
            message.includes("artıq") ||
            message.includes("movcuddur") ||
            message.includes("mövcuddur") ||
            message.includes("sebetde") ||
            message.includes("səbətdə") ||
            message.includes("favor") ||
            message.includes("sevimli")
        );
    };


    /* =========================================================
       SHOW MORE
    ========================================================= */

    const handleShowMore = () => {

        setVisibleLength(
            (prev) => prev + 700
        );

    };


    const handleShowLess = () => {

        setVisibleLength(100);

    };


    const isFullVisible =
        visibleLength >=
        (
            product?.description
                ?.length || 0
        );


    /* =========================================================
       DISTANCE SHOW MORE
    ========================================================= */

    const handleShowMoree = () => {

        setVisibleLengthh(
            (prev) => prev + 700
        );

    };


    const handleShowLesss = () => {

        setVisibleLengthh(100);

    };


    const isFullVisiblee =
        visibleLengthh >=
        (
            product?.distance
                ?.length || 0
        );


    /* =========================================================
       FETCH PRODUCT
    ========================================================= */

    useEffect(() => {

        let isMounted = true;


        const fetchProduct = async () => {

            try {

                setLoading(true);

                setError("");

                setProduct(null);


                const url = userInfo?._id
                    ? `${process.env.REACT_APP_API_BASE_URL}/api/qolbaq/id/${qolbaq_id}/${userInfo._id}`
                    : `${process.env.REACT_APP_API_BASE_URL}/api/qolbaq/id/${qolbaq_id}`;


                const response =
                    await axios.get(url);


                if (!isMounted) {
                    return;
                }


                const data =
                    response?.data;


                if (
                    data &&
                    data.getById
                ) {

                    setProduct(
                        data.getById
                    );

                    setVisibleLength(100);

                    setVisibleLengthh(100);

                } else {

                    setError(
                        "Məhsul tapılmadı. Bu məhsul silinmiş və ya artıq mövcud olmaya bilər."
                    );

                }

            } catch (err) {

                if (!isMounted) {
                    return;
                }


                console.error(
                    "Məhsul alınarkən xəta baş verdi:",
                    err?.response?.data ||
                        err
                );


                const status =
                    err?.response?.status;


                if (status === 404) {

                    setError(
                        "Bu məhsul artıq mövcud deyil və ya silinib."
                    );

                } else {

                    const errorMessage =
                        getErrorMessage(err);


                    setError(
                        `Məhsul detalları yüklənərkən xəta baş verdi.\n\nSəbəb: ${errorMessage}`
                    );

                }

            } finally {

                if (isMounted) {

                    setLoading(false);

                }

            }

        };


        fetchProduct();


        return () => {

            isMounted = false;

        };

    }, [
        qolbaq_id,
        userInfo?._id,
        retryCount,
    ]);


    /* =========================================================
       RETRY
    ========================================================= */

    const handleRetry = () => {

        setError("");

        setLoading(true);

        setRetryCount(
            (prev) => prev + 1
        );

    };


    /* =========================================================
       ADD / REMOVE CART
    ========================================================= */

    const handleAddToCart = async (
        selectedProduct
    ) => {

        if (
            !selectedProduct?._id
        ) {

            toast.error(
                "Məhsulun identifikasiya məlumatı tapılmadı."
            );

            return;
        }


        if (
            addingToCart ||
            addingToFavorite
        ) {
            return;
        }


        try {

            setAddingToCart(true);

            setError("");


            /* -------------------------------------------------
               ƏGƏR ARTİQ SƏBƏTDƏDİRSƏ → SİL
            ------------------------------------------------- */

            if (
                isInCart &&
                cartItem?._id
            ) {

                await deleteTodo(
                    cartItem._id
                ).unwrap();


                toast.success(
                    "Məhsul səbətdən uğurla silindi."
                );


                return;
            }


            /* -------------------------------------------------
               STOCK YOXDURSA
            ------------------------------------------------- */

            if (
                selectedProduct.stock <= 0
            ) {

                toast.error(
                    "Bu məhsul hazırda mövcud deyil."
                );

                return;
            }


            /* -------------------------------------------------
               SƏBƏTƏ ƏLAVƏ ET
            ------------------------------------------------- */

            await addTodo({
                productId:
                    selectedProduct._id,
            }).unwrap();


            toast.success(
                "Məhsul səbətə uğurla əlavə edildi."
            );

        } catch (err) {

            console.error(
                "Səbət əməliyyatında xəta:",
                err
            );


            if (
                isAlreadyAddedError(err)
            ) {

                toast.info(
                    "Bu məhsul artıq səbətdədir."
                );

                return;
            }


            const errorMessage =
                getErrorMessage(err);


            toast.error(
                `Səbət əməliyyatı uğursuz oldu. Səbəb: ${errorMessage}`,
                {
                    autoClose: 6000,
                }
            );

        } finally {

            setAddingToCart(false);

        }

    };


    /* =========================================================
       ADD / REMOVE FAVORITE
    ========================================================= */

    const handleAddToFavorie =
        async (
            selectedProduct
        ) => {

            if (
                !selectedProduct?._id
            ) {

                toast.error(
                    "Məhsulun identifikasiya məlumatı tapılmadı."
                );

                return;
            }


            if (
                addingToFavorite ||
                addingToCart
            ) {
                return;
            }


            try {

                setAddingToFavorite(
                    true
                );

                setError("");


                /* ---------------------------------------------
                   ƏGƏR ARTİQ FAVORİDƏDİRSƏ → SİL
                --------------------------------------------- */

                if (
                    isFavorite &&
                    favoriteItem?._id
                ) {

                    await deleteeTodo(
                        favoriteItem._id
                    ).unwrap();


                    toast.success(
                        "Məhsul sevimlilərdən uğurla silindi."
                    );


                    return;
                }


                /* ---------------------------------------------
                   FAVORİYƏ ƏLAVƏ ET
                --------------------------------------------- */

                await addTodoo({
                    productId:
                        selectedProduct._id,
                }).unwrap();


                toast.success(
                    "Məhsul sevimlilərə uğurla əlavə edildi."
                );

            } catch (err) {

                console.error(
                    "Favori əməliyyatında xəta:",
                    err
                );


                if (
                    isAlreadyAddedError(err)
                ) {

                    toast.info(
                        "Bu məhsul artıq sevimlilərinizdədir."
                    );

                    return;
                }


                const errorMessage =
                    getErrorMessage(err);


                toast.error(
                    `Favori əməliyyatı uğursuz oldu. Səbəb: ${errorMessage}`,
                    {
                        autoClose: 6000,
                    }
                );

            } finally {

                setAddingToFavorite(
                    false
                );

            }

        };


    /* =========================================================
       LOADING
    ========================================================= */

    if (loading) {

        return (

            <div
                className="
                    min-h-screen
                    bg-gray-50
                    dark:bg-black

                    flex
                    items-center
                    justify-center

                    px-4
                "
            >

                <div
                    className="
                        w-full
                        max-w-md

                        bg-white
                        dark:bg-gray-900

                        rounded-3xl

                        shadow-xl

                        border
                        border-gray-200
                        dark:border-gray-800

                        p-8

                        text-center
                    "
                >

                    <div
                        className="
                            w-16
                            h-16

                            mx-auto

                            rounded-2xl

                            bg-blue-50
                            dark:bg-blue-500/10

                            flex
                            items-center
                            justify-center

                            mb-5
                        "
                    >

                        <div
                            className="
                                w-8
                                h-8

                                border-4
                                border-blue-200
                                dark:border-blue-900

                                border-t-blue-600
                                dark:border-t-blue-400

                                rounded-full

                                animate-spin
                            "
                        />

                    </div>


                    <h2
                        className="
                            text-xl
                            font-bold

                            text-gray-800
                            dark:text-white

                            mb-2
                        "
                    >
                        Məhsul yüklənir...
                    </h2>


                    <p
                        className="
                            text-sm

                            text-gray-500
                            dark:text-gray-400
                        "
                    >
                        Məhsul haqqında məlumatlar
                        hazırlanır. Zəhmət olmasa,
                        gözləyin.
                    </p>

                </div>

            </div>

        );

    }


    /* =========================================================
       ERROR
    ========================================================= */

    if (error) {

        return (

            <div
                className="
                    min-h-screen
                    bg-gray-50
                    dark:bg-black

                    flex
                    items-center
                    justify-center

                    px-4
                "
            >

                <div
                    className="
                        w-full
                        max-w-lg

                        bg-white
                        dark:bg-gray-900

                        rounded-3xl

                        shadow-xl

                        border
                        border-red-200
                        dark:border-red-900/50

                        p-6
                        sm:p-8
                    "
                >

                    <div
                        className="
                            flex
                            flex-col
                            items-center

                            text-center
                        "
                    >

                        <div
                            className="
                                w-16
                                h-16

                                rounded-2xl

                                bg-red-50
                                dark:bg-red-500/10

                                text-red-600
                                dark:text-red-400

                                flex
                                items-center
                                justify-center

                                mb-5
                            "
                        >

                            <FaExclamationTriangle
                                size={26}
                            />

                        </div>


                        <h2
                            className="
                                text-xl
                                sm:text-2xl

                                font-bold

                                text-gray-800
                                dark:text-white

                                mb-3
                            "
                        >
                            Xəta baş verdi
                        </h2>


                        <p
                            className="
                                text-sm
                                sm:text-base

                                leading-6

                                text-red-700
                                dark:text-red-400

                                whitespace-pre-line
                                break-words
                            "
                        >
                            {error}
                        </p>


                        <div
                            className="
                                flex
                                flex-col
                                sm:flex-row

                                gap-3

                                mt-6

                                w-full
                                sm:w-auto
                            "
                        >

                            <button
                                type="button"
                                onClick={
                                    handleRetry
                                }
                                className="
                                    inline-flex
                                    items-center
                                    justify-center

                                    gap-2

                                    bg-blue-600
                                    hover:bg-blue-700

                                    text-white

                                    px-6
                                    py-3

                                    rounded-xl

                                    font-semibold

                                    transition
                                "
                            >

                                <FaSyncAlt />

                                Yenidən cəhd et

                            </button>


                            <button
                                type="button"
                                onClick={() =>
                                    navigate(-1)
                                }
                                className="
                                    inline-flex
                                    items-center
                                    justify-center

                                    gap-2

                                    bg-gray-100
                                    hover:bg-gray-200

                                    dark:bg-gray-800
                                    dark:hover:bg-gray-700

                                    text-gray-700
                                    dark:text-white

                                    px-6
                                    py-3

                                    rounded-xl

                                    font-semibold

                                    transition
                                "
                            >

                                <FaArrowLeft />

                                Geri qayıt

                            </button>

                        </div>

                    </div>

                </div>

            </div>

        );

    }


    /* =========================================================
       NO PRODUCT
    ========================================================= */

    if (!product) {

        return (

            <div
                className="
                    min-h-screen
                    bg-gray-50
                    dark:bg-black

                    flex
                    items-center
                    justify-center

                    px-4
                "
            >

                <div className="text-center">

                    <div
                        className="
                            text-6xl
                            mb-5
                        "
                    >
                        📦
                    </div>


                    <h2
                        className="
                            text-2xl
                            font-bold

                            mb-3

                            text-gray-800
                            dark:text-white
                        "
                    >
                        Məhsul tapılmadı
                    </h2>


                    <p
                        className="
                            text-gray-500
                            dark:text-gray-400

                            mb-6
                        "
                    >
                        Axtardığınız məhsul mövcud
                        deyil və ya silinib.
                    </p>


                    <button
                        type="button"
                        onClick={() =>
                            navigate(-1)
                        }
                        className="
                            inline-flex
                            items-center

                            gap-2

                            bg-blue-600
                            hover:bg-blue-700

                            text-white

                            px-6
                            py-3

                            rounded-xl

                            font-semibold

                            transition
                        "
                    >

                        <FaArrowLeft />

                        Geri qayıt

                    </button>

                </div>

            </div>

        );

    }


    /* =========================================================
       MAIN
    ========================================================= */

    return (

        <div
            className="
                min-h-screen
                w-full

                overflow-x-hidden

                bg-white
                dark:bg-black

                text-gray-800
                dark:text-white
            "
        >

            {/* =====================================================
                PRODUCT DETAIL
            ====================================================== */}

            <div
                className="
                    w-full
                    max-w-7xl
                    mx-auto

                    px-3
                    sm:px-5
                    lg:px-8
                    xl:px-10

                    py-5
                    sm:py-8
                    lg:py-10
                "
            >

                <div
                    className="
                        grid
                        grid-cols-1
                        lg:grid-cols-2

                        gap-8
                        lg:gap-12
                        xl:gap-16
                    "
                >

                    {/* =================================================
                        PRODUCT IMAGES
                    ================================================== */}

                    <div
                        className="
                            w-full
                            min-w-0
                            max-w-2xl
                            mx-auto
                        "
                    >

                        {Array.isArray(
                            product.photo
                        ) &&
                        product.photo.length >
                            0 ? (

                            <>

                                {/* BIG IMAGE */}

                                <Swiper
                                    spaceBetween={10}
                                    navigation

                                    thumbs={{
                                        swiper:
                                            thumbsSwiper &&
                                            !thumbsSwiper.destroyed
                                                ? thumbsSwiper
                                                : null,
                                    }}

                                    modules={[
                                        Navigation,
                                        Thumbs,
                                    ]}

                                    className="
                                        w-full

                                        overflow-hidden

                                        rounded-2xl
                                        sm:rounded-3xl

                                        mb-3
                                        sm:mb-4
                                    "
                                >

                                    {product.photo.map(
                                        (
                                            photo,
                                            index
                                        ) => (

                                            <SwiperSlide
                                                key={
                                                    index
                                                }
                                            >

                                                <div
                                                    className="
                                                        w-full

                                                        bg-gray-100
                                                        dark:bg-gray-900

                                                        rounded-2xl
                                                        sm:rounded-3xl

                                                        overflow-hidden
                                                    "
                                                >

                                                    <img
                                                        src={
                                                            photo
                                                        }
                                                        alt={`${product.title} - şəkil ${
                                                            index +
                                                            1
                                                        }`}
                                                        className="
                                                            w-full

                                                            h-[300px]
                                                            xs:h-[340px]
                                                            sm:h-[420px]
                                                            lg:h-[500px]
                                                            xl:h-[540px]

                                                            object-cover

                                                            select-none
                                                        "
                                                    />

                                                </div>

                                            </SwiperSlide>

                                        )
                                    )}

                                </Swiper>


                                {/* THUMBNAILS */}

                                <Swiper
                                    onSwiper={
                                        setThumbsSwiper
                                    }

                                    spaceBetween={8}

                                    slidesPerView={
                                        product.photo
                                            .length >
                                        4
                                            ? 4
                                            : product
                                                  .photo
                                                  .length
                                    }

                                    breakpoints={{
                                        480: {
                                            slidesPerView:
                                                product
                                                    .photo
                                                    .length >
                                                5
                                                    ? 5
                                                    : product
                                                          .photo
                                                          .length,
                                        },

                                        640: {
                                            slidesPerView:
                                                product
                                                    .photo
                                                    .length >
                                                6
                                                    ? 6
                                                    : product
                                                          .photo
                                                          .length,
                                        },
                                    }}

                                    modules={[
                                        Thumbs,
                                    ]}

                                    watchSlidesProgress

                                    className="
                                        w-full
                                        overflow-hidden
                                    "
                                >

                                    {product.photo.map(
                                        (
                                            photo,
                                            index
                                        ) => (

                                            <SwiperSlide
                                                key={
                                                    index
                                                }
                                            >

                                                <img
                                                    src={
                                                        photo
                                                    }
                                                    alt={`Kiçik şəkil ${
                                                        index +
                                                        1
                                                    }`}
                                                    className="
                                                        w-full

                                                        h-16
                                                        sm:h-20
                                                        lg:h-24

                                                        object-cover

                                                        rounded-xl

                                                        border
                                                        border-gray-200
                                                        dark:border-gray-800

                                                        cursor-pointer

                                                        hover:opacity-80

                                                        transition
                                                    "
                                                />

                                            </SwiperSlide>

                                        )
                                    )}

                                </Swiper>

                            </>

                        ) : (

                            <div
                                className="
                                    w-full

                                    h-[300px]
                                    sm:h-[420px]
                                    lg:h-[500px]

                                    flex
                                    flex-col

                                    items-center
                                    justify-center

                                    bg-gray-100
                                    dark:bg-gray-900

                                    rounded-2xl
                                    sm:rounded-3xl

                                    text-gray-500
                                    dark:text-gray-400

                                    border
                                    border-gray-200
                                    dark:border-gray-800

                                    px-5

                                    text-center
                                "
                            >

                                <div
                                    className="
                                        text-5xl
                                        mb-4
                                    "
                                >
                                    🖼️
                                </div>


                                <p
                                    className="
                                        font-medium
                                    "
                                >
                                    Məhsul şəkli
                                    mövcud deyil
                                </p>


                                <p
                                    className="
                                        text-sm
                                        mt-1
                                    "
                                >
                                    Bu məhsul üçün şəkil
                                    əlavə edilməyib.
                                </p>

                            </div>

                        )}

                    </div>


                    {/* =================================================
                        PRODUCT INFO
                    ================================================== */}

                    <div
                        className="
                            w-full
                            min-w-0

                            flex
                            flex-col
                            justify-center

                            pt-2
                            lg:pt-0
                        "
                    >

                        {/* TITLE */}

                        <h1
                            className="
                                text-2xl
                                sm:text-3xl
                                lg:text-4xl

                                font-bold

                                leading-tight

                                mb-4

                                break-words
                            "
                        >
                            {product.title}
                        </h1>


                        {/* PRICE */}

                        <div
                            className="
                                flex
                                flex-wrap

                                items-center

                                gap-x-3
                                gap-y-1

                                mb-5
                            "
                        >

                            <span
                                className="
                                    text-base
                                    sm:text-lg

                                    font-medium

                                    text-gray-500
                                    dark:text-gray-400
                                "
                            >
                                Qiymət:
                            </span>


                            {product.discountApplied ? (

                                <>

                                    <span
                                        className="
                                            text-base
                                            sm:text-lg

                                            text-red-500

                                            line-through
                                        "
                                    >
                                        {
                                            product.originalPrice
                                        }₼
                                    </span>


                                    <span
                                        className="
                                            text-2xl
                                            sm:text-3xl

                                            font-bold

                                            text-green-600
                                        "
                                    >
                                        {
                                            product.price
                                        }₼
                                    </span>

                                </>

                            ) : (

                                <span
                                    className="
                                        text-2xl
                                        sm:text-3xl

                                        font-bold

                                        text-blue-600
                                    "
                                >
                                    {
                                        product.price
                                    }₼
                                </span>

                            )}

                        </div>


                        {/* STOCK */}

                        <div
                            className="
                                inline-flex
                                w-fit

                                items-center

                                gap-2

                                mb-5

                                px-3
                                py-2

                                rounded-xl

                                bg-gray-50
                                dark:bg-gray-900
                            "
                        >

                            <span
                                className="
                                    text-sm
                                    sm:text-base

                                    font-semibold
                                "
                            >
                                Mövcudluq:
                            </span>


                            {product.stock > 0 ? (

                                <span
                                    className="
                                        text-sm
                                        sm:text-base

                                        font-semibold

                                        text-green-600
                                    "
                                >
                                    Mövcuddur
                                </span>

                            ) : (

                                <span
                                    className="
                                        text-sm
                                        sm:text-base

                                        font-semibold

                                        text-red-600
                                    "
                                >
                                    Mövcud deyil
                                </span>

                            )}

                        </div>


                        {/* DESCRIPTION */}

                        {product.description && (

                            <div
                                className="
                                    mb-6
                                    min-w-0
                                "
                            >

                                <h3
                                    className="
                                        font-bold

                                        text-base
                                        sm:text-lg

                                        mb-2
                                    "
                                >
                                    Məhsul haqqında
                                </h3>


                                <p
                                    className="
                                        text-sm
                                        sm:text-base

                                        leading-7

                                        text-gray-600
                                        dark:text-gray-300

                                        break-words
                                    "
                                >

                                    {(
                                        product.description ||
                                        ""
                                    ).slice(
                                        0,
                                        visibleLength
                                    )}


                                    {visibleLength <
                                        (
                                            product
                                                .description ||
                                            ""
                                        ).length &&
                                        "..."}
                                </p>


                                <div
                                    className="
                                        flex
                                        flex-wrap

                                        gap-3

                                        mt-2
                                    "
                                >

                                    {!isFullVisible && (

                                        <button
                                            type="button"
                                            onClick={
                                                handleShowMore
                                            }
                                            className="
                                                text-blue-600

                                                hover:text-blue-700

                                                font-semibold

                                                text-sm
                                            "
                                        >
                                            Daha çox göstər
                                        </button>

                                    )}


                                    {visibleLength >
                                        100 && (

                                        <button
                                            type="button"
                                            onClick={
                                                handleShowLess
                                            }
                                            className="
                                                text-blue-600

                                                hover:text-blue-700

                                                font-semibold

                                                text-sm
                                            "
                                        >
                                            Daha az göstər
                                        </button>

                                    )}

                                </div>

                            </div>

                        )}


                        {/* DISTANCE */}

                        {product.distance && (

                            <div
                                className="
                                    mb-6
                                    min-w-0
                                "
                            >

                                <h3
                                    className="
                                        font-bold

                                        text-base
                                        sm:text-lg

                                        mb-2
                                    "
                                >
                                    Ərazi / məsafə
                                </h3>


                                <p
                                    className="
                                        text-sm
                                        sm:text-base

                                        leading-7

                                        text-gray-600
                                        dark:text-gray-300

                                        break-words
                                    "
                                >

                                    {(
                                        product.distance ||
                                        ""
                                    ).slice(
                                        0,
                                        visibleLengthh
                                    )}


                                    {visibleLengthh <
                                        (
                                            product
                                                .distance ||
                                            ""
                                        ).length &&
                                        "..."}
                                </p>


                                <div
                                    className="
                                        flex
                                        flex-wrap

                                        gap-3

                                        mt-2
                                    "
                                >

                                    {!isFullVisiblee && (

                                        <button
                                            type="button"
                                            onClick={
                                                handleShowMoree
                                            }
                                            className="
                                                text-blue-600

                                                hover:text-blue-700

                                                font-semibold

                                                text-sm
                                            "
                                        >
                                            Daha çox göstər
                                        </button>

                                    )}


                                    {visibleLengthh >
                                        100 && (

                                        <button
                                            type="button"
                                            onClick={
                                                handleShowLesss
                                            }
                                            className="
                                                text-blue-600

                                                hover:text-blue-700

                                                font-semibold

                                                text-sm
                                            "
                                        >
                                            Daha az göstər
                                        </button>

                                    )}

                                </div>

                            </div>

                        )}


                        {/* CATEGORY */}

                        <div
                            className="
                                mb-5

                                flex
                                flex-wrap

                                items-center

                                gap-2
                            "
                        >

                            <span
                                className="
                                    text-sm

                                    font-semibold

                                    text-gray-500
                                    dark:text-gray-400
                                "
                            >
                                Kateqoriya:
                            </span>


                            <span
                                className="
                                    inline-flex
                                    items-center

                                    px-3
                                    py-1.5

                                    rounded-full

                                    bg-blue-50
                                    dark:bg-blue-500/10

                                    text-blue-600
                                    dark:text-blue-400

                                    text-sm

                                    font-semibold
                                "
                            >
                                {
                                    product.catagory
                                }
                            </span>

                        </div>


                        {/* RATING */}

                        <div
                            className="
                                flex
                                items-center

                                gap-1

                                text-yellow-500

                                text-lg
                                sm:text-xl

                                mb-7
                            "
                        >

                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaStar />

                        </div>


                        {/* =================================================
                            ACTION BUTTONS
                        ================================================== */}

                        <div
                            className="
                                w-full
                                max-w-xl

                                flex
                                flex-col

                                gap-3
                            "
                        >

                            {/* =================================================
                                CART
                            ================================================== */}

                            <button
                                type="button"

                                onClick={() =>
                                    handleAddToCart(
                                        product
                                    )
                                }

                                disabled={
                                    addingToCart ||
                                    addingToFavorite ||
                                    (
                                        !isInCart &&
                                        product.stock === 0
                                    )
                                }

                                className={`
                                    w-full

                                    min-h-[52px]

                                    px-5
                                    py-3

                                    rounded-2xl

                                    font-bold

                                    shadow-md

                                    transition-all
                                    duration-200

                                    flex
                                    items-center
                                    justify-center

                                    gap-2

                                    active:scale-[0.98]

                                    ${
                                        isInCart
                                            ? "border-2 border-emerald-300 bg-emerald-50 text-emerald-700 hover:border-red-300 hover:bg-red-50 hover:text-red-600 dark:border-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-400 dark:hover:border-red-800 dark:hover:bg-red-950/40 dark:hover:text-red-400"
                                            : product.stock ===
                                              0
                                            ? "bg-gray-400 text-white cursor-not-allowed"
                                            : addingToCart
                                            ? "bg-blue-500 text-white cursor-wait"
                                            : addingToFavorite
                                            ? "bg-blue-600/60 text-white cursor-not-allowed"
                                            : "bg-blue-600 text-white hover:bg-blue-700 hover:shadow-lg"
                                    }
                                `}
                            >

                                {addingToCart ? (

                                    <>

                                        <span
                                            className="
                                                w-5
                                                h-5

                                                border-2

                                                border-current

                                                border-t-transparent

                                                rounded-full

                                                animate-spin
                                            "
                                        />


                                        <span>
                                            {
                                                isInCart
                                                    ? "Səbətdən silinir..."
                                                    : "Səbətə əlavə edilir..."
                                            }
                                        </span>

                                    </>

                                ) : isInCart ? (

                                    <>

                                        <FaShoppingCart />

                                        <span>
                                            Səbətinizdədir
                                            {" "}
                                            — silmək üçün basın
                                        </span>

                                    </>

                                ) : product.stock === 0 ? (

                                    <>

                                        <FaShoppingCart />

                                        <span>
                                            Mövcud deyil
                                        </span>

                                    </>

                                ) : (

                                    <>

                                        <FaShoppingCart />

                                        <span>
                                            Səbətə əlavə et
                                        </span>

                                    </>

                                )}

                            </button>


                            {/* =================================================
                                FAVORITE
                            ================================================== */}

                            <button
                                type="button"

                                onClick={() =>
                                    handleAddToFavorie(
                                        product
                                    )
                                }

                                disabled={
                                    addingToFavorite ||
                                    addingToCart
                                }

                                className={`
                                    w-full

                                    min-h-[52px]

                                    px-5
                                    py-3

                                    rounded-2xl

                                    font-bold

                                    shadow-md

                                    transition-all
                                    duration-200

                                    flex
                                    items-center
                                    justify-center

                                    gap-2

                                    active:scale-[0.98]

                                    ${
                                        isFavorite
                                            ? "border-2 border-red-300 bg-red-50 text-red-600 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-700 dark:border-red-800 dark:bg-red-950/30 dark:text-red-400 dark:hover:border-gray-700 dark:hover:bg-gray-900 dark:hover:text-gray-300"
                                            : addingToFavorite
                                            ? "bg-green-500 text-white cursor-wait"
                                            : addingToCart
                                            ? "bg-green-700/60 text-white cursor-not-allowed"
                                            : "bg-green-600 text-white hover:bg-green-700 hover:shadow-lg"
                                    }
                                `}
                            >

                                {addingToFavorite ? (

                                    <>

                                        <span
                                            className="
                                                w-5
                                                h-5

                                                border-2

                                                border-current

                                                border-t-transparent

                                                rounded-full

                                                animate-spin
                                            "
                                        />


                                        <span>
                                            {
                                                isFavorite
                                                    ? "Sevimlilərdən silinir..."
                                                    : "Sevimlilərə əlavə edilir..."
                                            }
                                        </span>

                                    </>

                                ) : isFavorite ? (

                                    <>

                                        <FaHeart />

                                        <span>
                                            Sevimlilərinizdədir
                                            {" "}
                                            — silmək üçün basın
                                        </span>

                                    </>

                                ) : (

                                    <>

                                        <FaHeart />

                                        <span>
                                            Sevimlilərə əlavə et
                                        </span>

                                    </>

                                )}

                            </button>

                        </div>

                    </div>

                </div>

            </div>


            {/* =====================================================
                OTHER PRODUCTS
            ====================================================== */}

            <section
                className="
                    w-full

                    mt-8
                    sm:mt-14
                    lg:mt-20

                    mb-10
                    sm:mb-16
                    lg:mb-24

                    overflow-hidden
                "
            >

                <div
                    className="
                        w-full
                        max-w-7xl
                        mx-auto

                        px-3
                        sm:px-5
                        lg:px-8
                        xl:px-10
                    "
                >

                    {/* SECTION HEADER */}

                    <div
                        className="
                            relative

                            mb-5
                            sm:mb-8

                            text-center
                        "
                    >

                        <div
                            className="
                                mx-auto

                                mb-3

                                h-1

                                w-12
                                sm:w-16

                                rounded-full

                                bg-gradient-to-r
                                from-blue-600
                                to-violet-600
                            "
                        />


                        <h2
                            className="
                                text-xl
                                sm:text-2xl
                                lg:text-3xl

                                font-bold

                                text-gray-900
                                dark:text-white
                            "
                        >
                            Digər məhsullar
                        </h2>


                        <p
                            className="
                                mt-2

                                text-xs
                                sm:text-sm

                                text-gray-500
                                dark:text-gray-400
                            "
                        >
                            Bu kateqoriyadakı digər
                            məhsullara baxın
                        </p>

                    </div>


                    {/* PRODUCT CARDS */}

                    <div
                        className="
                            w-full

                            min-w-0

                            overflow-hidden
                        "
                    >

                        <ProductCard
                            catagory={
                                product.catagory
                            }
                        />

                    </div>

                </div>

            </section>

        </div>

    );

};


export default Detalp;